module.exports = __webpack_public_path__ + "static/media/sakuravee.27508bbe.jpg";